var map = {
	"./ag-active.png": "B+3D",
	"./bb-active.png": "g+Ss",
	"./ob-active.png": "fdTj",
	"./og-active.png": "TTrq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kEOg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/video ^\.\/.*\-active\.png$
// module id = kEOg
// module chunks = 3